import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    border: '1px solid',
  },
  icon: {
    '& + fieldset': {
      border: '1px',
    },
  },
  select: {
    '&': {
      ...tw`border border-gray-500 border-opacity-25 px-4 py-2 rounded-2xl bg-gray-500 bg-opacity-5 placeholder-gray-700 w-full`,
      'font-size': 'inherit',
    },
    '&:focus': tw`rounded-2xl`,
  },
}));
